import { PopperElement, Props } from 'tippy.js';
import { ModalHTMLElement } from './modal';
import { PhoneOtpModule, PhoneOtpModuleHTMLElement } from './phone-otp-module';

export function initAcmeRevocationForm(): void {
    // Prise en charge des boutons à l'intérieur d'un contenu Tippy
    document.querySelectorAll<PopperElement>('[data-tippy]').forEach($tippy => {
        if (typeof $tippy._tippy === 'undefined') {
            return;
        }

        const onMountParent = $tippy._tippy.props.onMount;
        $tippy._tippy.setProps({
            onMount(instance) {
                if (true !== (instance.reference as InitializableHTMLElement<Props>).AcmeRevocationFormInitialized) {
                    onMountParent(instance);

                    (instance.reference as InitializableHTMLElement<Props>).AcmeRevocationFormInitialized = true;
                    searchAndInitRevocationFormModals(instance.popper as HTMLElement);
                }
            },
        });
    });

    // Prise en charge des boutons présents au chargement de la page
    searchAndInitRevocationFormModals(document);
}

/**
 * Recherche des boutons de revocation
 * 
 * @param {HTMLElement|Document} $parent Parent dans lequel faire la recherche
 * 
 * @return {void}
 */
function searchAndInitRevocationFormModals($parent: HTMLElement|Document): void {
    $parent.querySelectorAll<HTMLButtonElement>('.js-acme-revocation-entity-open-otp-button').forEach($openOtpButton => {
        const entityRefExt = $openOtpButton.dataset.entityRefExt;
        const otpModalId = $openOtpButton.dataset.otpModalId;
        const $otpModal = otpModalId ? document.querySelector<ModalHTMLElement>('#' + otpModalId) : null;
        const revocationModalId = $openOtpButton.dataset.revocationModalId;
        const $revocationModal = revocationModalId ? document.querySelector<ModalHTMLElement>('#' + revocationModalId) : null;
        const $revocationModalEntityField = $revocationModal?.querySelector<HTMLInputElement>('.js-acme-revocation-entity-field');

        if (entityRefExt && $otpModal && $revocationModal && $revocationModalEntityField) {
            new RevokeAcmeEntityOtp($openOtpButton, entityRefExt, $otpModal, $revocationModal, $revocationModalEntityField);
        }
    });
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface InitializableHTMLElement<T> extends HTMLElement {
    AcmeRevocationFormInitialized?: boolean;
}

class RevokeAcmeEntityOtp {
    $openOtpButton: HTMLButtonElement;
    entityRefExt: string;
    $otpModal: ModalHTMLElement;
    $revocationModal: ModalHTMLElement;
    $revocationModalEntityField: HTMLInputElement;

    constructor(
        $openOtpButton: HTMLButtonElement,
        entityRefExt: string,
        $otpModal: ModalHTMLElement,
        $revocationModal: ModalHTMLElement,
        $revocationModalEntityField: HTMLInputElement
    ) {
        this.$openOtpButton = $openOtpButton;
        this.entityRefExt = entityRefExt;
        this.$otpModal = $otpModal;
        this.$revocationModal = $revocationModal;
        this.$revocationModalEntityField = $revocationModalEntityField;

        // Au clique sur le bouton de révocation, on ouvre la modal de demande d'OTP
        $openOtpButton.addEventListener('click', evt => {
            evt.preventDefault();
            this.$otpModal.open();
        });

        const $phoneOtpModule = document.querySelector<PhoneOtpModuleHTMLElement>('.js-acme-revocation-entity-otp-module');
        if ($phoneOtpModule) {
            new PhoneOtpModule($phoneOtpModule);

            // Une fois l'OTP validé, on ouvre la modal demandant la raison de la révocation
            $phoneOtpModule.addEventListener('phone_otp_module_success', () => {
                this.$revocationModalEntityField.value = this.entityRefExt;
                this.$revocationModal.open();
            });
        }
    }
}
